import { render, staticRenderFns } from "./AltaAcuerdoV2.vue?vue&type=template&id=47055f1f"
import script from "./AltaAcuerdoV2.vue?vue&type=script&lang=js"
export * from "./AltaAcuerdoV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports